<div class="wiz-box">
  <div class="heading">{{'wizard.step-3.title' | translate}}</div>

  <div class="wiz-content">
    <p class="text-muted mt-2">{{'wizard.step-3.p-1' | translate}}</p>

    <table class="w-100 my-5">
      <thead>
      <tr>
        <th>{{'wizard.step-3.user' | translate}}</th>
        <th>{{'wizard.step-3.email' | translate}}</th>
        <th>{{'wizard.step-3.role' | translate}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="!userList?.length; else elseBlock">
        <td colspan="4">
          <div style="padding-top: 0.4rem; color: #b6b6b6">
            {{'wizard.step-3.no-user' | translate}}
          </div>
        </td>
      </tr>
      <ng-template #elseBlock>
        <tr *ngFor="let user of userList">
          <td class="text-bold">{{user.name}}</td>
          <td>{{user.email}}</td>
          <td>{{user.groups | userGroups}}</td>
          <td class="wiz-icon-btns text-righ d-flex">
            <btn class="wiz-icon-btn" [icon]="'fas-pen'" [routerLink]="['/plugplay/step-3/edit', user.id]"></btn>
            <btn *ngIf="user.deletable && user.id > 0" class="wiz-icon-btn" [icon]="'fas-trash'" (click)="delete(user.id)"></btn>
          </td>
        </tr>
      </ng-template>
      </tbody>
    </table>
    <button class="primary-btn" routerLink="/plugplay/step-3/new"><i class="far fa-plus"></i><span>{{'wizard.step-3.btn-create-user' | translate}}</span></button>
  </div>
  <div class="wiz-footer">
    <button class="secondary-btn" routerLink="/plugplay/step-2"><i class="fas fa-chevron-left"></i><span>{{'wizard.step-3.btn-back' | translate}}</span></button>
    <button class="primary-btn" routerLink="/plugplay/step-4" (click)="setHighestLastStepCompleted.emit(2)">
      <span>{{(userList?.length === 0 && !isLoading ?'wizard.step-3.btn-continue-without-users': 'wizard.step-3.btn-next-step') | translate}}</span>
      <i class="fas fa-chevron-right"></i></button>
  </div>
</div>
